/* ============================================================
   THE TEDDY SOCIETY — Bear link capture
   File: assets/tts-bear-link.js

   Any link on the site pointing at Find Your Bear with a ?bear=
   query string (homepage carousel, vibe chips, mood/lifestyle/love/
   mature category pages) gets its bear handle written to
   sessionStorage the instant it's clicked — BEFORE the browser
   navigates. tts-builder.js reads it as a fallback if the query
   string itself doesn't survive the trip (this can happen under
   Shopify's theme preview link rewriting, or any future redirect/
   caching layer). Belt-and-braces so the "click a bear, land in the
   funnel with that bear" flow can't silently break.
   ============================================================ */
(function () {
  'use strict';

  function extractBearHandle(href) {
    if (!href || href.indexOf('find-your-bear') === -1) return null;
    try {
      var url = new URL(href, window.location.origin);
      return url.searchParams.get('bear');
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="find-your-bear"]');
    if (!link) return;
    var handle = extractBearHandle(link.getAttribute('href'));
    if (!handle) return;
    try {
      window.sessionStorage.setItem('tts-pending-bear', handle);
    } catch (e) {
      /* private mode etc — the ?bear= query string is still the primary path */
    }
  }, true);
})();
